/* eslint-disable */
export default {
  mute: 'Désactiver le micro',
  unmute: 'Activer le micro',
  hangup: 'Raccrocher',
  reject: 'Rejeter',
  hold: 'Mettre en attente',
  onHold: 'En attente',
  transfer: 'Transférer',
  more: 'Plus',
  stopRecord: 'Arrêter l’enregistrement',
  record: 'Enregistrer',
  showKeypad: 'Clavier téléphonique',
  hideKeypad: 'Masquer le clavier téléphonique',
  unHold: 'Reprendre',
  forward: 'Transférer',
  ignore: 'Ignorer',
  voicemail: 'À la messagerie vocale',
  custom: 'Personnaliser',
  answerAndEnd: 'Répondre et raccrocher',
  answerAndHold: 'Répondre et mettre en attente',
  answer: 'Répondre',
  completeTransfer: 'Exécuter le transfert',
  reply: 'Répondre',
  add: 'Ajouter',
  mergeCall: 'Fusionner avec l’appel en cours',
  endCallForEveryone: 'Mettre fin à l’appel pour tous',
  leaveCall: 'Quitter l’appel',
  leaveOrEndCall: 'Quitter l’appel ou y mettre fin?',
} as const;

// @key: @#@"mute"@#@ @source: @#@"Mute"@#@
// @key: @#@"unmute"@#@ @source: @#@"Unmute"@#@
// @key: @#@"hangup"@#@ @source: @#@"Hang up"@#@
// @key: @#@"reject"@#@ @source: @#@"Reject"@#@
// @key: @#@"hold"@#@ @source: @#@"Hold"@#@
// @key: @#@"onHold"@#@ @source: @#@"On Hold"@#@
// @key: @#@"transfer"@#@ @source: @#@"Transfer"@#@
// @key: @#@"more"@#@ @source: @#@"More"@#@
// @key: @#@"stopRecord"@#@ @source: @#@"Stop Recording"@#@
// @key: @#@"record"@#@ @source: @#@"Record"@#@
// @key: @#@"showKeypad"@#@ @source: @#@"Keypad"@#@
// @key: @#@"hideKeypad"@#@ @source: @#@"Hide Keypad"@#@
// @key: @#@"unHold"@#@ @source: @#@"Unhold"@#@
// @key: @#@"forward"@#@ @source: @#@"Forward"@#@
// @key: @#@"ignore"@#@ @source: @#@"Ignore"@#@
// @key: @#@"voicemail"@#@ @source: @#@"To Voicemail"@#@
// @key: @#@"custom"@#@ @source: @#@"Custom"@#@
// @key: @#@"answerAndEnd"@#@ @source: @#@"Answer & End"@#@
// @key: @#@"answerAndHold"@#@ @source: @#@"Answer & Hold"@#@
// @key: @#@"answer"@#@ @source: @#@"Answer"@#@
// @key: @#@"completeTransfer"@#@ @source: @#@"Complete transfer"@#@
// @key: @#@"reply"@#@ @source: @#@"Reply"@#@
// @key: @#@"add"@#@ @source: @#@"Add"@#@
// @key: @#@"mergeCall"@#@ @source: @#@"Merge with active call"@#@
// @key: @#@"endCallForEveryone"@#@ @source: @#@"End call for everyone"@#@
// @key: @#@"leaveCall"@#@ @source: @#@"Leave call"@#@
// @key: @#@"leaveOrEndCall"@#@ @source: @#@"Leave or end call?"@#@
